import { render } from "./BuyModal.vue?vue&type=template&id=62b3a060&scoped=true"
import script from "./BuyModal.vue?vue&type=script&lang=js"
export * from "./BuyModal.vue?vue&type=script&lang=js"

import "./BuyModal.vue?vue&type=style&index=0&id=62b3a060&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b3a060"]])

export default __exports__